const AppBarDefaultProps = {
  actions: null
}

export default AppBarDefaultProps
